<div class="is-relative">
    <div class="content-type-form">
        <h2 class="title is-2">Change email</h2>

        <div class="field is-horizontal">
            <div class="field-label field-label-tooltip">
                <label for="email-change-control" class="has-text-weight-bold has-text-primary">
                    New email
                </label>
                <isav-tooltip-display tooltipKey="Person:email"></isav-tooltip-display>
            </div>
            <div class="field-body">
                <div class="field is-grouped">
                    <div class="control is-expanded">
                        <input
                            id="email-change-control"
                            type="email"
                            class="input"
                            autocomplete="new-email"
                            [formControl]="emailControl"
                        />
                    </div>
                    <div class="control">
                        <button isavBtn color="success" (click)="changeEmail()">
                            Change email
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <h2 class="title is-2 mt-6">Change password</h2>

        <form [formGroup]="passwordForm" autocomplete="off" class="pb-6">
            <input [value]="value.email" type="email" style="display: none" name="email" />

            <div class="field is-horizontal">
                <div class="field-label field-label-tooltip">
                    <label
                        for="current-password-control"
                        class="has-text-weight-bold has-text-primary"
                    >
                        Current password
                    </label>
                    <isav-tooltip-display
                        tooltipKey="Person:previousPassword"
                    ></isav-tooltip-display>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control">
                            <input
                                id="current-password-control"
                                class="input"
                                type="password"
                                formControlName="previousPassword"
                                placeholder="Current password"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <isav-password-input
                formControlName="newPassword"
                label="New password"
                tooltipKey="Person:newPassword"
            ></isav-password-input>

            <div class="field is-horizontal">
                <div class="field-label field-label-tooltip"></div>
                <div class="field-body">
                    <div class="field">
                        <div class="control">
                            <button isavBtn color="success" (click)="changePassword()">
                                Change password
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <isav-loader-overlay *ngIf="loading"></isav-loader-overlay>
</div>
